import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '../utils/auth'
import handleErrors from '../utils/handleErrors'
import NProgress from 'nprogress'

import 'nprogress/nprogress.css'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/layout/blank'),
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('@/views/Login')
        },
        {
          path: 'riskControl',
          name: 'riskControl',
          component: () => import('@/views/RiskControl')
        }
      ]
    },

    // 默认布局(包含头部以及顶部)
    {
      path: '/home',
      component: () => import('@/layout/default'),
      // redirect: '/home/serverCheck',
      children: [
        {
          path: 'welcome',
          name: 'homeWelcomeIndex',
          component: () => import('@/views/Welcome')
        },
        {
          path: 'test',
          component: () => import('@/views/Test'),
          name: 'test'
        },

        // T1
        // 员工管理
        {
          path: 'userManage',
          name: 'userManageIndex',
          component: () => import('@/views/T1/UserManage')
        },
        {
          path: 'userManage/create',
          name: 'userManageCreate',
          component: () => import('@/views/T1/UserManage/Create')
        },
        {
          path: 'userManage/details/:id',
          name: 'userManageDetails',
          props: true,
          component: () => import('@/views/T1/UserManage/Details')
        },
        {
          path: 'userManage/editor/:id',
          name: 'userManageEditor',
          props: true,
          component: () => import('@/views/T1/UserManage/Editor')
        },
        // 服务商查询
        {
          path: 'serverCheck',
          name: 'ServerCheck',
          component: () => import('@/views/T1/ServerCheck'),
        },
        {
          path: 'serverCheck/create',
          name: 'serverCheckCreate',
          component: () => import('@/views/T1/ServerCheck/Create')
        },
        {
          path: 'serverCheck/details',
          name: 'serverCheckDetails',
          component: () => import('@/views/T1/ServerCheck/Details')
        },
        {
          path: 'serverCheck/editor',
          name: 'serverCheckEditor',
          component: () => import('@/views/T1/ServerCheck/Editor')
        },
        // 准入注册
        {
          path: 'accessRegist',
          name: 'accessRegist',
          component: () => import('@/views/T1/AccessRegist')
        },
        {
          path: 'accessRegist/examine',
          name: 'accessRegistExamine',
          component: () => import('@/views/T1/AccessRegist/Examine')
        },
        // 准入注册 end
        // 接口配置
        {
          path: 'interfaceConfig',
          name: 'interfaceConfig',
          component: () => import('@/views/T1/InterfaceConfig')
        },
        {
          path: 'interfaceConfig/edit',
          name: 'interfaceConfigEdit',
          component: () => import('@/views/T1/InterfaceConfig/Editor')
        },
        {
          path: 'interfaceConfig/check',
          name: 'interfaceConfigCheck',
          component: () => import('@/views/T1/InterfaceConfig/Check')
        },
        // 接口配置 end

        // T2
        // 供应商查询 start
        {
          path: 'supplierCheck',
          name: 'supplierCheck/index',
          component: () => import('@/views/T2/SupplierCheck')
        },
        {
          path: 'supplierCheck/details/:id/:supId',
          name: 'supplierCheck/details',
          props: true,
          component: () => import('@/views/T2/SupplierCheck/Details')
        },
        // 供应商查询 end
        // 受理发行
        {
          path: 'acceptIssuance',
          name: 'acceptIssuance',
          component: () => import('@/views/T2/AcceptIssuance')
        },
        {
          path: 'acceptIssuance/details/:id',
          name: 'acceptIssuance/details',
          props: true,
          component: () => import('@/views/T2/AcceptIssuance/Details')
        },
        // 受理发行 end
        // 供应商 - 资料注册
        {
          path: 'supplierRegistered',
          name: 'supplierRegistered',
          component: () => import('@/views/T2/SupplierRegistered')
        },
        {
          // path: 'supplierRegistered/details/:id/:supId',
          path: 'supplierRegistered/details/:id',
          name: 'supplierRegistered/details',
          props: true,
          component: () => import('@/views/T2/SupplierRegistered/Check')
        },
        {
          path: 'supplierRegistered/editor/:id',
          name: 'supplierRegistered/editor',
          props: true,
          component: () => import('@/views/T2/SupplierRegistered/Editor')
        },
        {
          path: 'supplierRegistered/create',
          name: 'supplierRegistered/create',
          component: () => import('@/views/T2/SupplierRegistered/Create')
        },
        // 商户查询
        {
          path: 'merchantCheck',
          name: 'merchantCheckIndex',
          component: () => import('@/views/T2/MerchantCheck'),
        },
        {
          path: 'merchantCheck/details/:merId',
          name: 'merchantCheckDetails',
          props: true,
          component: () => import('@/views/T2/MerchantCheck/Details')
        },
        // 资料进件
        {
          path: 'submitInfo',
          name: 'submitInfo',
          component: () => import('@/views/T2/SubmitInfo')
        },
        {
          path: 'submitInfo/create',
          name: 'submitInfoCreate',
          component: () => import('@/views/T2/SubmitInfo/Create')
        },
        {
          path: 'submitInfo/details/:merId',
          name: 'submitInfo/details',
          component: () => import('@/views/T2/SubmitInfo/Details')
        },
        // 业务发行 start
        {
          path: 'businessIssuance',
          name: 'businessIssuance/index',
          component: () => import('@/views/T2/BusinessIssuance')
        },
        {
          path: 'businessIssuance/details/:merId',
          name: 'businessIssuance/details',
          component: () => import('@/views/T2/BusinessIssuance/Details')
        },
        {
          path: 'channelIssuance',
          name: 'ChannelIssuanceIndex',
          component: () => import('@/views/T2/ChannelIssuance')
        },
        {
          path: 'channelIssuance/details/:merId',
          name: 'ChannelIssuanceDetails',
          props: true,
          component: () => import('@/views/T2/ChannelIssuance/Details')
        },
        // 用户地图
        {
          path: 'userMap',
          name: 'userMapIndex',
          component: () => import('@/views/T2/UserMap')
        },

        // T3
        // 商户系统审核 start
        {
          path: 'merchantAudit',
          name: 'merchantAudit/index',
          component: () => import('@/views/T3/MerchantAudit')
        },
        {
          path: 'merchantAudit/details/:merId/:letThrough',
          name: 'merchantAudit/details',
          props: true,
          component: () => import('@/views/T3/MerchantAudit/Details'),
          meta: { scrollToTop: true, listPath: 'merchantAudit' }
        },
        // 商户系统审核 end
        // 人工复核 start
        {
          path: 'artificialAudit',
          name: 'artificialAudit/index',
          component: () => import('@/views/T3/ArtificialAudit')
        },
        {
          path: 'artificialAudit/details/:merId',
          name: 'artificialAudit/details',
          props: true,
          component: () => import('@/views/T3/ArtificialAudit/Details'),
          meta: { scrollToTop: true, listPath: 'artificialAudit' }
        },
        // 人工复核 end

        // 供应商注册
        {
          path: 'supplierRegistration',
          name: 'SupplierRegisteredIndex',
          component: () => import('@/views/T3/SupplierRegistration')
        },
        {
          path: 'supplierRegistration/details/:status/:id',
          // path: 'supplierRegistration/details/:id',
          name: 'SupplierRegisteredDetails',
          props: true,
          component: () => import('@/views/T3/SupplierRegistration/Details')
        },
        // {
        //   path: 'supplierRegistration/editor/:id',
        //   name: 'SupplierRegisteredEditor',
        //   props: true,
        //   component: () => import('@/views/T3/SupplierRegistration/Editor')
        // },

        // 受理发行
        {
          path: 'acceptReview',
          name: 'AcceptReview',
          component: () => import('@/views/T3/AcceptReview')
        },
        {
          path: 'acceptReview/details/:id',
          name: 'AcceptReviewDetails',
          props: true,
          component: () => import('@/views/T3/AcceptReview/Details')
        },
        // 风控模版 riskControlTemplate
        {
          path: 'riskControlTemplate',
          name: 'RiskControlTemplate',
          component: () => import('@/views/T3/RiskControlTemplate')
        },
        {
          path: 'riskControlTemplate/create',
          name: 'RiskControlTemplateCreate',
          component: () => import('@/views/T3/RiskControlTemplate/Create')
        },
        {
          path: 'riskControlTemplate/preview',
          name: 'RiskControlTemplatePreview',
          component: () => import('@/views/T3/RiskControlTemplate/Preview')
        },
        // {
        //   path: 'userManage/details/:id',
        //   name: 'userManageDetails',
        //   props: true,
        //   component: () => import('@/views/T1/UserManage/Details')
        // },
        // {
        //   path: 'userManage/editor/:id',
        //   name: 'userManageEditor',
        //   props: true,
        //   component: () => import('@/views/T1/UserManage/Editor')
        // },

        // 风控审计
        {
          path: 'riskControlReview',
          name: 'RiskControlReviewIndex',
          component: () => import('@/views/T3/RiskControlReview')
        },
        {
          path: 'riskControlReview/details',
          name: 'RiskControlReviewDetails',
          component: () => import('@/views/T3/RiskControlReview/Details')
        },

        // 风控执行
        {
          path: 'riskControlExecute',
          name: 'RiskControlExecuteIndex',
          component: () => import('@/views/T3/RiskControlExecute')
        },
        {
          path: 'riskControlExecute/details/:merNo/:supId',
          name: 'RiskControlExecuteDetails',
          props: true,
          component: () => import('@/views/T3/RiskControlExecute/Details')
        },
        // 贷后管理 - 行为评分
        {
          path: 'behaviorScore',
          name: 'behaviorScore',
          component: () => import('@/views/T3/DHGL/BehaviorScore')
        },
        // 贷后管理 - 行为评分 详情
        {
          path: 'behaviorScore/details/:merNo',
          name: 'behaviorScore/details',
          props: true,
          component: () => import('@/views/T3/DHGL/BehaviorScore/Details'),
        },
        // 贷后管理 - 不良列表
        {
          path: 'badRecord',
          name: 'badRecord',
          component: () => import('@/views/T3/DHGL/BadRecord')
        },
        // 贷后管理 - 不良列表 详情
        {
          path: 'badRecord/details/:merNo/:merId/:supId',
          name: 'badRecordDetails',
          component: () => import('@/views/T3/DHGL/BadRecord/Details'),
          meta: { scrollToTop: true, tabs: '1', listPath: 'badRecord' }
        },
        // 贷后管理 - 额度调控记录
        {
          path: 'quotaChange',
          name: 'quotaChange',
          component: () => import('@/views/T3/DHGL/QuotaChange')
        },
        // 贷后管理 - 额度调控记录 详情
        {
          path: 'quotaChange/details/:merNo',
          name: 'quotaChangeDetails',
          props: true,
          component: () => import('@/views/T3/DHGL/QuotaChange/Details'),
          meta: { scrollToTop: true, listPath: 'quotaChange' }
        },

        // 交易规则设置
        {
          path: 'tradingRulesSetting',
          name: 'TradingRulesSettingIndex',
          component: () => import('@/views/T3/TradingRulesSetting')
        },
        {
          path: 'tradingRulesSetting/addRules',
          name: 'TradingRulesSettingAddRules',
          component: () => import('@/views/T3/TradingRulesSetting/addRules')
        },
        {
          path: 'tradingRulesSetting/editorRules/:riskId',
          name: 'TradingRulesSettingEditorRules',
          props: true,
          component: () => import('@/views/T3/TradingRulesSetting/editorRules')
        },

        // 涉控黄名单
        {
          path: 'involvedYellowlist',
          name: 'InvolvedYellowlistIndex',
          component: () => import('@/views/T3/InvolvedYellowlist')
        },
        {
          path: 'involvedYellowlist/editor/:targetType/:targetId/:id',
          name: 'InvolvedYellowlistEditor',
          props: true,
          component: () => import('@/views/T3/InvolvedYellowlist/Editor')
        },
        {
          path: 'aloneExecuteRisk/:targetType/:targetId',
          name: 'AloneExecuteRisk',
          props: true,
          component: () => import('@/views/T3/InvolvedYellowlist/Execute')
        },

        // 涉控黑名单
        {
          path: 'involvedBlacklist',
          name: 'InvolvedBlacklistIndex',
          component: () => import('@/views/T3/InvolvedBlacklist')
        },
        {
          path: 'involvedBlacklist/editor/:targetType/:targetId/:id',
          name: 'InvolvedBlacklistEditor',
          props: true,
          component: () => import('@/views/T3/InvolvedBlacklist/Editor')
        },

        // T4
        // 渠道查询
        {
          path: 'channelQuery',
          name: 'ChannelQueryIndex',
          component: () => import('@/views/T4/ChannelQuery')
        },
        {
          path: 'channelQuery/create',
          name: 'ChannelQueryCreate',
          component: () => import('@/views/T4/ChannelQuery/Create')
        },
        {
          path: 'channelQuery/details/:id',
          name: 'ChannelQueryDetails',
          props: true,
          component: () => import('@/views/T4/ChannelQuery/Details')
        },
        {
          path: 'channelQuery/editor/:id',
          name: 'ChannelQueryEditor',
          props: true,
          component: () => import('@/views/T4/ChannelQuery/Editor')
        },

        // 申请反馈
        {
          path: 'applyFeedback',
          name: 'ApplyFeedbackIndex',
          component: () => import('@/views/T4/ApplyFeedback')
        },
        {
          path: 'applyFeedback/details/:merId',
          name: 'ApplyFeedbackDetails',
          props: true,
          component: () => import('@/views/T4/ApplyFeedback/Details')
        },

        // 路由映射
        {
          path: 'routeMapping',
          name: 'RouteMappingIndex',
          component: () => import('@/views/T4/RouteMapping')
        },
        {
          path: 'routeMapping/details/:id',
          name: 'RouteMappingDetails',
          props: true,
          component: () => import('@/views/T4/RouteMapping/Details')
        },

        // 通道反馈
        {
          path: 'channelFeedback',
          name: 'ChannelFeedbackIndex',
          component: () => import('@/views/T4/ChannelFeedback')
        },
        {
          path: 'channelFeedback/details/:merId',
          name: 'ChannelFeedbackDetails',
          props: true,
          component: () => import('@/views/T4/ChannelFeedback/Details')
        },

        // 支付通道
        {
          path: 'paymentChannel',
          name: 'PaymentChannelIndex',
          component: () => import('@/views/T4/PaymentChannel')
        },
        {
          path: 'paymentChannel/details/:id',
          name: 'PaymentChannelDetails',
          props: true,
          component: () => import('@/views/T4/PaymentChannel/Details')
        },
        {
          path: 'paymentChannel/create',
          name: 'PaymentChannelCreate',
          component: () => import('@/views/T4/PaymentChannel/Create')
        },
        {
          path: 'paymentChannel/editor/:id',
          name: 'PaymentChannelEditor',
          props: true,
          component: () => import('@/views/T4/PaymentChannel/Editor')
        },

        // 支付/路由映射
        {
          path: 'paymentRouting',
          name: 'PaymentRoutingIndex',
          component: () => import('@/views/T4/PaymentRouting')
        },
        {
          path: 'paymentRouting/details/:merId',
          name: 'PaymentRoutingDetails',
          props: true,
          component: () => import('@/views/T4/PaymentRouting/Details')
        },

        // T5
        // 保理交易/当前交易
        {
          path: 'factoringCurrent',
          name: 'FactoringCurrentIndex',
          props: true,
          component: () => import('@/views/T5/FactoringCurrent')
        },
        {
          path: 'factoringCurrent/details/:id',
          name: 'FactoringCurrentDetails',
          props: true,
          component: () => import('@/views/T5/FactoringCurrent/Details')
        },

        // 保理交易/历史交易
        {
          path: 'factoringHistory',
          name: 'FactoringHistoryIndex',
          props: true,
          component: () => import('@/views/T5/FactoringHistory')
        },
        {
          path: 'factoringHistory/details/:id',
          name: 'FactoringHistoryDetails',
          props: true,
          component: () => import('@/views/T5/FactoringHistory/Details')
        },

        // 支付交易/当前交易
        {
          path: 'paymentCurrent',
          name: 'PaymentCurrentIndex',
          component: () => import('@/views/T5/PaymentCurrent')
        },
        {
          path: 'paymentCurrent/details/:id',
          alias: 'paymentHistory/details/:id',
          name: 'PaymentCurrentDetails',
          props: true,
          component: () => import('@/views/T5/PaymentCurrent/Details')
        },

        // 支付交易/历史交易 详情页和当前交易页面一样 所以使用当前交易的
        {
          path: 'paymentHistory',
          name: 'PaymentHistoryIndex',
          component: () => import('@/views/T5/PaymentHistory')
        },

        // T6
        // 手续费利润
        {
          path: 'profitFee',
          name: 'ProfitFeeIndex',
          component: () => import('@/views/T6/ProfitFee')
        },
        {
          path: 'profitFee/details/:merNo/:periodNo',
          name: 'ProfitFeeDetails',
          props: true,
          component: () => import('@/views/T6/ProfitFee/Details')
        },
        {
          path: 'profitFee/payment/:id',
          name: 'ProfitFeePayment',
          props: true,
          component: () => import('@/views/T6/ProfitFee/Payment')
        },
        // 逾期利润
        {
          path: 'profitOverdue',
          name: 'ProfitOverdueIndex',
          component: () => import('@/views/T6/ProfitOverdue')
        },
        {
          path: 'profitOverdue/details/:merNo',
          name: 'ProfitOverdueDetails',
          props: true,
          component: () => import('@/views/T6/ProfitOverdue/Details')
        },
        // 资产利润
        {
          path: 'profitAssets',
          name: 'ProfitAssetsIndex',
          component: () => import('@/views/T6/ProfitAssets')
        },
        {
          path: 'profitAssets/details/:id',
          name: 'ProfitAssetsDetails',
          component: () => import('@/views/T6/ProfitAssets/Details')
        },
        // 额度交易利润
        {
          path: 'profitQuotaTrading',
          name: 'ProfitQuotaTradingIndex',
          component: () => import('@/views/T6/ProfitQuotaTrading')
        },
        // 贷记交易利润
        {
          path: 'profitLoanTransaction',
          name: 'ProfitLoanTransactionIndex',
          component: () => import('@/views/T6/ProfitLoanTransaction')
        },
        {
          path: 'profitLoanTransaction/details/:id',
          name: 'ProfitLoanTransactionDetails',
          component: () => import('@/views/T6/ProfitLoanTransaction/Details')
        },
        // 提现利润
        {
          path: 'profitWithdraw',
          name: 'ProfitWithdrawIndex',
          component: () => import('@/views/T6/ProfitWithdraw')
        },
        // 余额交易利润
        {
          path: 'profitBalanceTransaction',
          name: 'ProfitBalanceTransactionIndex',
          component: () => import('@/views/T6/ProfitBalanceTransaction')
        },
        {
          path: 'profitBalanceTransaction/details/:id',
          name: 'ProfitBalanceTransactionDetails',
          component: () => import('@/views/T6/ProfitBalanceTransaction/Details')
        },
        // 差错处理
        {
          path: 'errorHandling',
          name: 'ErrorHandlingIndex',
          component: () => import('@/views/T6/ErrorHandling')
        },
        {
          path: 'errorHandling/details/:id',
          name: 'ErrorHandlingDetails',
          component: () => import('@/views/T6/ErrorHandling/Details')
        },
        // 对账数据
        {
          path: 'reconciliationData',
          name: 'ReconciliationData',
          component: () => import('@/views/T6/ReconciliationData')
        },
        // 异常订单
        {
          path: 'errorOrder',
          name: 'ErrorOrder',
          component: () => import('@/views/T6/ErrorOrder')
        },

        // 保理利润
        {
          path: 'profitFactoring',
          name: 'ProfitFactoringIndex',
          component: () => import('@/views/T6/ProfitFactoring')
        },
        // 支付利润
        {
          path: 'profitPayment',
          name: 'ProfitPaymentIndex',
          component: () => import('@/views/T6/ProfitPayment')
        },
        {
          path: 'profitPayment/details/:id',
          name: 'ProfitPaymentDetails',
          component: () => import('@/views/T6/ProfitPayment/Details')
        },
        // 服务商账务
        {
          path: 'supplierBill',
          name: 'SupplierBillIndex',
          component: () => import('@/views/T6/SupplierBill')
        },
        {
          path: 'supplierBill/details/:id',
          name: 'SupplierBillDetails',
          component: () => import('@/views/T6/SupplierBill/Details')
        },
        // 账户管控
        {
          path: 'accountControl',
          name: 'AccountControlIndex',
          component: () => import('@/views/T6/AccountControl')
        },
        {
          path: 'accountControl/details/:id',
          name: 'AccountControlDetails',
          props: true,
          component: () => import('@/views/T6/AccountControl/Details')
        },


        // T7
        // D10客户
        {
          path: 'overdueClientOne',
          name: 'OverdueClientOne',
          component: () => import('@/views/T7/overdueClientOne')
        },
        {
          path: 'overdueClientOne/details/:merNo/:periodNo',
          name: 'OverdueClientOne/details',
          component: () => import('@/views/T7/overdueClientOne/Details'),
          props: true
        },
        {
          path: 'overdueClientOne/strainIndex',
          name: 'OverdueClientOne/StrainIndex',
          component: () => import('@/views/T7/overdueClientOne/StrainIndex')
        },
        {
          path: 'overdueClientOne/strainIndex/details',
          name: 'OverdueClientOne/StrainDetails',
          component: () => import('@/views/T7/overdueClientOne/StrainDetails'),
          props: true
        },
        // D20客户
        {
          path: 'overdueClientTwo',
          name: 'OverdueClientTwo',
          component: () => import('@/views/T7/overdueClientTwo')
        },
        {
          path: 'overdueClientTwo/details/:merNo/:periodNo',
          name: 'OverdueClientTwo/details',
          component: () => import('@/views/T7/overdueClientTwo/Details'),
          props: true
        },
        {
          path: 'overdueClientTwo/strainIndex',
          name: 'OverdueClientTwo/StrainIndex',
          component: () => import('@/views/T7/overdueClientTwo/StrainIndex')
        },
        {
          path: 'overdueClientTwo/strainIndex/details',
          name: 'OverdueClientTwo/StrainDetails',
          component: () => import('@/views/T7/overdueClientTwo/StrainDetails'),
          props: true
        },
        // D30客户
        {
          path: 'overdueClientThree',
          name: 'OverdueClientThree',
          component: () => import('@/views/T7/overdueClientThree')
        },
        {
          path: 'overdueClientThree/details/:merNo/:periodNo',
          name: 'OverdueClientThree/details',
          component: () => import('@/views/T7/overdueClientThree/Details'),
          props: true
        },
        // {
        //   path: 'overdueClientThree/strainIndex',
        //   name: 'OverdueClientThree/StrainIndex',
        //   component: () => import('@/views/T7/overdueClientThree/StrainIndex')
        // },
        // {
        //   path: 'overdueClientThree/strainIndex/details',
        //   name: 'OverdueClientThree/StrainDetails',
        //   component: () => import('@/views/T7/overdueClientThree/StrainDetails'),
        //   props: true
        // },
        // 还款查询
        {
          path: 'repaymentCheck',
          name: 'RepaymentCheck',
          component: () => import('@/views/T7/repaymentCheck')
        },
        {
          path: 'repaymentCheck/details/:merNo/:periodNo',
          name: 'RepaymentCheck/details',
          component: () => import('@/views/T7/repaymentCheck/Details'),
          props: true
        },
        {
          path: 'repaymentCheck/strainIndex',
          name: 'RepaymentCheck/StrainIndex',
          component: () => import('@/views/T7/repaymentCheck/StrainIndex')
        },
        {
          path: 'repaymentCheck/strainIndex/details',
          name: 'RepaymentCheck/StrainDetails',
          component: () => import('@/views/T7/repaymentCheck/StrainDetails'),
          props: true
        },
        // 当期应还款
        {
          path: 'currentRepayment',
          name: 'CurrentRepayment',
          component: () => import('@/views/T7/currentRepayment')
        },
        {
          path: 'currentRepayment/details/:merNo/:periodNo',
          name: 'CurrentRepayment/details',
          component: () => import('@/views/T7/currentRepayment/Details'),
          props: true
        },
        // 账单查询
        {
          path: 'billCheck',
          name: 'BillCheck',
          component: () => import('@/views/T7/billCheck')
        },
        {
          path: 'billCheck/details/:merNo/:periodNo',
          name: 'BillCheck/details',
          component: () => import('@/views/T7/billCheck/Details'),
          props: true
        },
        // {
        //   path: 'currentRepayment/strainIndex',
        //   name: 'CurrentRepayment/StrainIndex',
        //   component: () => import('@/views/T7/currentRepayment/StrainIndex')
        // },
        // {
        //   path: 'currentRepayment/strainIndex/details',
        //   name: 'CurrentRepayment/StrainDetails',
        //   component: () => import('@/views/T7/currentRepayment/StrainDetails'),
        //   props: true
        // },

        // T7日常工作-摄控名单
        {
          path: 'involveControl',
          name: 'InvolveControl',
          component: () => import('@/views/T7/involveControl')
        },
        {
          path: 'involveControl/details/:merNo/:periodNo',
          name: 'InvolveControl/details',
          component: () => import('@/views/T7/involveControl/Details'),
          props: true
        },

        // T7商户激活
        {
          path: 'merActivate',
          name: 'MerActivate',
          component: () => import('@/views/T7/merActivate')
        },
        {
          path: 'merActivate/details/:merId/:bankExit',
          name: 'MerActivate/details',
          component: () => import('@/views/T7/merActivate/Details'),
          props: true
        },
        // T7供应商激活
        {
          path: 'supActivate',
          name: 'SupActivate',
          component: () => import('@/views/T7/supActivate')
        },
        {
          path: 'supActivate/details/:id/',
          name: 'SupActivate/details',
          component: () => import('@/views/T7/supActivate/Details'),
          props: true
        },

        // T8
        // 客户运营
        {
          path: 'customerOperation',
          name: 'CustomerOperation',
          component: () => import('@/views/T8/CustomerOperation')
        },
        {
          path: 'customerOperation/details',
          name: 'CustomerOperation/Details',
          redirect: 'customerOperation/details/guide',
          component: () => import('@/views/T8/CustomerOperation/Details'),
          children: [{
            // 引导页
            path: 'guide',
            name: 'CustomerOperation/Details/Guide',
            component: () => import('@/views/T8/CustomerOperation/pages/Guide')
          }, {
            // 轮播图
            path: 'carousel',
            name: 'CustomerOperation/Details/Carousel',
            component: () => import('@/views/T8/CustomerOperation/pages/Carousel')
          }, {
            // 抵用券
            path: 'voucher',
            name: 'CustomerOperation/Details/Voucher',
            component: () => import('@/views/T8/CustomerOperation/pages/Voucher')
          }, {
            // ICON
            path: 'icon',
            name: 'CustomerOperation/Details/Icon',
            component: () => import('@/views/T8/CustomerOperation/pages/Icon')
          }, {
            // 悬浮窗
            path: 'dialog',
            name: 'CustomerOperation/Details/Dialog',
            component: () => import('@/views/T8/CustomerOperation/pages/Dialog')
          }, {
            // 模块管理
            path: 'module',
            name: 'CustomerOperation/Details/Module',
            component: () => import('@/views/T8/CustomerOperation/pages/Module')
          }]
        },

        // T8客户线索
        {
          path: 'clientClue',
          name: 'ClientClue',
          component: () => import('@/views/T8/clientClue')
        },
        {
          path: 'clientClue/details/:id/',
          name: 'ClientClue/details',
          component: () => import('@/views/T8/clientClue/Details'),
          props: true
        },
        // 线索转化
        {
          path: 'changeClue',
          name: 'ChangeClue',
          component: () => import('@/views/T8/changeClue')
        },
        {
          path: 'changeClue/details/:id/',
          name: 'ChangeClue/details',
          component: () => import('@/views/T8/changeClue/Details'),
          props: true
        },
        // T9
        // API鉴权
        {
          path: 'appAuthorize',
          name: 'APPAuthorize',
          component: () => import('@/views/T9/APIAuthorize')
        },
        {
          path: 'appAuthorize/details/:action',
          name: 'APPAuthorize/details',
          component: () => import('@/views/T9/APIAuthorize/Details'),
          props: true
        },
        // API监控
        {
          path: 'appMonitor',
          name: 'APPMonitor',
          component: () => import('@/views/T9/APIMonitor')
        },
        {
          path: 'appMonitor/details',
          name: 'APPMonitor/details',
          component: () => import('@/views/T9/APIMonitor/Details'),
          props: true
        },
        // 项目列表
        {
          path: 'appList',
          name: 'APPList',
          component: () => import('@/views/T9/APIList')
        },
        {
          path: 'appList/details/:action',
          name: 'APPList/details',
          component: () => import('@/views/T9/APIList/Details'),
          props: true
        },
        // 调用日志
        {
          path: 'appLog',
          name: 'APPLog',
          component: () => import('@/views/T9/APILog')
        },
        {
          path: 'appLog/details',
          name: 'APPLog/details',
          component: () => import('@/views/T9/APILog/Details'),
          props: true
        },
        // 分析报告
        {
          path: 'appAnalyze',
          name: 'APPAnalyze',
          component: () => import('@/views/T9/APIAnalyze')
        }
      ]
    },

    {
      path: '*',
      name: '404',
      component: () => import('@/layout/error_404')
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  // 如果登录状态失效 则携带当前的完整路径并跳转回登录页
  // console.log(to);
  if (to.path !== '/' && !getToken()) {
    handleErrors._redirectLogin(to.fullPath)
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done();
})



const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(e => e)
}

export default router
